import axios from 'axios'
import { toLogin } from '@/utils/common'
import { getTicket } from '@/utils/cookies'
import { Dialog } from 'vant'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  const ignoreHeaders = ['h-x-app-name', 'h-x-app-version', 'h-x-app-key', 'h-x-app-server-port', 'h-x-cat-context']
  if (getTicket()) {
    config.headers['X-Ticket'] = getTicket()
  }

  let headers = config.headers ? config.headers : {}
  for (let header in config.headers) {
    let headerName = header.toLowerCase()
    if (ignoreHeaders.indexOf(headerName) < 0 && headerName.startsWith('h-x-')) {
      headers[headerName] = config.headers[header]
    }
  }

  config.headers = headers
  // if (config.url.indexOf('polymerize-api') > -1) {
  //   config.baseURL = process.env.ENV_CONFIG === 'production' ? `https://oms.homedo.com` : `https://oms.${process.env.ENV_CONFIG}.homedo.com`
  // }

  return config
}, error => {
  Promise.reject(error)
})

/* 请求统一处理：404、500、token失效等 */
service.interceptors.response.use(response => {
  // TODO 00004 ticket 验证未通过或已失效
  if (response && response.status === 200 && response.data && response.data.respCode === '0006') {
    Dialog.confirm({
      title: '',
      message: '用户信息验证未通过或已失效，请重新登陆'
    }).then(() => {
      // 判断环境 跳转不同登录页面
      toLogin()
    }).catch(() => {
      // 取消
    })
  }
  // TODO 404 跳转 404 页面 待构建 404页面
  if (response && response.status === 404) {
    return
  }
  // TODO 500 跳转500 页面 待构建 500页面
  if (response && response.status === 500) {
    return
  }
  return response
}, error => {
  // TODO 异常
  Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js